export default {
  true: 'true',
  false: 'false',
};
